<template>

    <div class="list">

        <div class="list__tr"
             v-show="isDesktop && list.length">

            <div class="list__tr__cell list__tr__edges pointer" @click="toggleAll">
                <img
                    :src="allChecked ? '/img/newsletters-v2/checkbox-2-on.svg' : '/img/newsletters-v2/checkbox-2-off.svg'"
                    class="img__20">
            </div>
            <div class="list__tr__cell list__tr__sender">
                <p class="text-baseSemibold-2 color__moon">{{ $t('cleaning_sender') }}</p>
            </div>
            <div class="list__tr__cell list__tr__others pointer" @click="sortByCount">
                <p class="text-baseSemibold-2"
                   :class="{
                    'color__moon': !sortedByCount,
                    'color__aquamarine': sortedByCount
                }">{{ $tc('cleaning_cards_received_emails', 2) }}</p>
                <img :src="`/img/newsletters-v2/chevron-down-full-${sortedByCount ? 'blue': 'grey'}.svg`"
                     class="img__24"
                     :class="{'list__tr__img-reverse': newslettersSort === ENUM.NEWSLETTERS.SORT.DESCENDING}">
            </div>
            <div class="list__tr__cell list__tr__others pointer" @click="sortByOpenRate">
                <p class="text-baseSemibold-2"
                   :class="{
                    'color__moon': !sortedByOpenRate,
                    'color__aquamarine': sortedByOpenRate
                }">{{ $t('cleaning_sort_open_rate') }}</p>
                <img :src="`/img/newsletters-v2/chevron-down-full-${sortedByOpenRate ? 'blue': 'grey'}.svg`"
                     :class="{'list__tr__img-reverse': newslettersSort === ENUM.NEWSLETTERS.SORT.LEAST_OPEN}"
                     class="img__24">
            </div>
            <div class="list__tr__cell list__tr__others pointer" @click="sortByOpenRate">
                <p class="text-baseSemibold-2 ml__8">{{ $t('spam') }}</p>
            </div>
            <div class="list__tr__cell list__tr__edges"></div>


        </div>

        <div class="list__scroll">
            <div v-if="!isDesktop">
                <div class="list__item"
                     :class="{'list__item__active': item.checked}"
                     v-for="(item, index) in localList"
                     :key="index"
                     @click="toggleItem(index)">

                    <div class="list__item__left">
                        <img
                            :src="item.checked ? '/img/newsletters-v2/checkbox-2-on.svg' : '/img/newsletters-v2/checkbox-2-off.svg'"
                            class="list__item__left__img">
                    </div>

                    <div class="list__item__middle">
                        <p>
                            <span class="list__item__middle__text text-xlSemibold-2">{{ item.name }} </span>
                            <span class="spoum-badge" v-show="Subscription.isSpoum(item)">{{ $t('spam') }}</span>
                        </p>
                        <p class="ellipsis-text">{{ item.sender }}</p>
                    </div>
                    <div class="list__item__right">
                        <div class="list__item__right__row">
                            <img src="/img/newsletters-v2/mail-blue.svg" class="list__item__right__row__img">
                            <p>{{ item.count }}</p>
                        </div>
                        <div class="list__item__right__row">
                            <img src="/img/newsletters-v2/mail-open-blue.svg" class="list__item__right__row__img">
                            <p>{{ item.openRate }} %</p>
                        </div>
                    </div>

                </div>
            </div>

            <div v-else>
                <div class="list__td pointer"
                     :class="{'list__item__active': item.checked}"
                     v-for="(item, index) in localList"
                     :key="index"
                     @click="toggleItem(index)">

                    <div class="list__td__cell list__td__edges pointer">
                        <img
                            :src="item.checked ? '/img/newsletters-v2/checkbox-2-on.svg' : '/img/newsletters-v2/checkbox-2-off.svg'"
                            class="img__20">
                    </div>
                    <div class="list__td__cell list__td__sender">
                        <div class="list__td__column">
                            <p class="ellipsis-text text-baseSemibold-2">{{ item.name }}</p>
                            <p class="ellipsis-text text-sRegular color__moon">{{ item.sender }}</p>
                        </div>
                    </div>
                    <div class="list__td__cell list__td__others">
                        <img src="/img/newsletters-v2/mail-blue.svg" class="list__td__ico">
                        <p class="text-lMedium">{{ item.count }}</p>
                    </div>
                    <div class="list__td__cell list__td__others">
                        <img src="/img/newsletters-v2/mail-open-blue.svg" class="list__td__ico">
                        <p class="text-lMedium">{{ item.openRate }} %</p>
                    </div>
                    <div class="list__td__cell list__td__others">
                        <span class="spoum-badge" v-show="Subscription.isSpoum(item)">{{ $t('spam') }}</span>
                    </div>
                    <div class="list__td__cell list__td__edges"></div>
                </div>
            </div>
        </div>

        <empty-spoum-area :subscriptions="list" :category="category"></empty-spoum-area>

        <actions-bar v-show="itemSelected"
                     :isList="true"
                     @action="action"></actions-bar>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '@/assets/ENUM'

import Tag from '@/modules/tag'

import Subscription from '@/helpers/subscription'

import ActionsBar from '@/components/newsletters-v2/ActionsBar'
import EmptySpoumArea from '@/components/newsletters-v2/EmptySpoumArea'
import Checkbox from '@/components/inputs/Checkbox'

export default {

    name: 'list',

    components: {
        ActionsBar,
        EmptySpoumArea,
        Checkbox
    },

    props: {
        list: {
            type: Array,
            default: () => []
        },

        searching: {
            type: Boolean,
            default: false
        },

        category: {
            type: String,
            default: ''
        }
    },

    watch: {
        list() {
            this.initdata()
        },

        countChecked(newValue) {
            this.updateCountSelectedNewsletters(newValue)
        },

        unselectedAllNewsletters() {
            this.toggleUnselectAll()
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'newslettersSort',
            'searchValue',
            'unselectedAllNewsletters'
        ]),

        ENUM() {
            return ENUM
        },

        Subscription() {
            return Subscription
        },

        itemSelected() {
            return this.localList.filter(item => item.checked).length > 0
        },

        allChecked() {
            return this.localList.length && this.localList.length === this.countChecked
        },

        countChecked() {
            return (this.localList.length && this.localList.filter(item => item.checked).length) || 0
        },

        sortedByCount() {
            return this.newslettersSort === ENUM.NEWSLETTERS.SORT.ASCENDING || this.newslettersSort === ENUM.NEWSLETTERS.SORT.DESCENDING
        },

        sortedByOpenRate() {
            return this.newslettersSort === ENUM.NEWSLETTERS.SORT.MOST_OPEN || this.newslettersSort === ENUM.NEWSLETTERS.SORT.LEAST_OPEN
        },

        computedTextSearching() {
            return this.localList.length
                ? this.$tc('cleaning_search_nb_results', this.localList.length, {'nb_results': this.localList.length, search: this.searchValue})
                : this.$t('cleaning_search_no_results')
        }

    },

    data() {
        return {
            localList: []
        }
    },

    mounted() {
        this.initdata()
    },

    methods: {

        ...Vuex.mapActions([
            'updateCountSelectedNewsletters',
            'updateNewslettersSort'
        ]),

        initdata() {
            this.localList = this.list
                .filter(item => item.type === ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS)
                .map(item => {
                    return {...item, checked: false}
                })
        },

        toggleItem(index) {
            this.localList[index].checked = !this.localList[index].checked
        },

        action(enumAction) {
            const senders = this.localList
                .filter(item => item.checked)
            this.$emit('action', {enumAction, senders})
        },

        toggleAll() {
            this.allChecked
                ? this.toggleUnselectAll()
                : this.toggleSelectAll()
        },

        toggleSelectAll() {
            Tag.clickGA(this, 'select_all')
            this.localList.forEach(item => item.checked = true)
        },

        toggleUnselectAll() {
            this.localList.forEach(item => item.checked = false)
        },

        sortByCount() {
            const sortBy = this.newslettersSort === ENUM.NEWSLETTERS.SORT.DESCENDING
                ? ENUM.NEWSLETTERS.SORT.ASCENDING
                : ENUM.NEWSLETTERS.SORT.DESCENDING
            this.updateNewslettersSort(sortBy)
        },

        sortByOpenRate() {
            const sortBy = this.newslettersSort === ENUM.NEWSLETTERS.SORT.LEAST_OPEN
                ? ENUM.NEWSLETTERS.SORT.MOST_OPEN
                : ENUM.NEWSLETTERS.SORT.LEAST_OPEN
            this.updateNewslettersSort(sortBy)
        }
    }
}
</script>

<style lang="scss" scoped>

@import "@/style/spoum.scss";

.list {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    flex-grow: 1;
    align-items: center;

    &__tr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: stretch;
        background-color: $timberwolf;
        border-bottom: 1px solid $divider;

        &__img-reverse {
            transform: rotate(180deg);
            z-index: -1; // fix error: "transform :after" is call after z-index, so is print on the top of fixed elements with z-index
        }

        &__cell {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            text-align: start;
            padding: 16px;
        }

        &__edges {
            width: 56px;
        }

        &__sender {
            flex: 2;
        }

        &__others {
            flex: 1;
        }
    }

    &__scroll {
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        overflow-y: scroll;
    }

    &__td {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: stretch;
        background-color: $white;
        border-bottom: 1px solid $divider;

        &__cell {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            text-align: start;
            padding: 32px 16px;
        }

        &__column {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
        }

        &__edges {
            width: 56px
        }

        &__sender {
            flex: 2;
        }

        &__others {
            flex: 1;
        }

        &__ico {
            width: 24px;
            object-fit: contain;
            margin: 0 8px 0 0;

            &:lang(ar-sa) {
                margin: 0 0 0 8px;
            }
        }
    }

    &__item {
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: solid 1px #e7e7e8;
        margin-bottom: 1px;
        background-color: $white;

        &__active {
            background-color: #e0f1fc;
            @media screen and (min-width: $above-tablet-length) {
                background-color: #f7fbfe;
            }
        }

        &__left {
            width: 52px;
            padding: 16px;

            &__img {
                width: 20px;
                object-fit: contain;

                &:lang(ar-sa) {
                    transform: scaleX(-1);
                }
            }
        }

        &__middle {
            display: flex;
            flex: 1;
            flex-direction: column;
            text-align: start;
            overflow: hidden;

            > p {
                display: flex;
                flex-direction: row;
            }

            &__text {
                margin: 0 4px 0 0;

                &:lang(ar-sa) {
                    margin: 0 0 0 4px;
                }
            }
        }

        &__right {
            width: 104px;
            padding: 16px;

            &__row {
                display: flex;
                flex-direction: row;
                white-space: nowrap;
                align-items: center;

                &__img {
                    width: 24px;
                    object-fit: contain;
                    margin-right: 8px;

                    &:lang(ar-sa) {
                        margin-left: 8px;
                        margin-right: 0;
                    }
                }
            }
        }
    }

}

</style>
